<template>
  <div id="q-app">
    <router-view />
  </div>
</template>

<script>
import { initializeApp } from '@firebase/app';
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from '@firebase/messaging';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { Dialog } from 'quasar';

export default {
  name: 'App',
  computed: {
    ...mapGetters('application', ['isFetchingFromAPI']),
  },

  watch: {
    isFetchingFromAPI(bool) {
      if (bool) {
        this.$q.loading.show({
          spinnerSize: 64,
        });
      }
      else {
        this.$q.loading.hide();
      }
    },
  },

  mounted() {
    document.addEventListener('backbutton', this.handleBackButton, true);

    const firebaseConfig = {
      apiKey: 'AIzaSyCHWvzTofYqq_GPDQebLSxo_yOkMKCdcd8',
      authDomain: 'kdn-demo.firebaseapp.com',
      projectId: 'kdn-demo',
      storageBucket: 'kdn-demo.appspot.com',
      messagingSenderId: '952453179278',
      appId: '1:952453179278:web:042d28fdbe6ecbc91326df',
    };
    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app, { vapidKey: 'BGuzP62iHHrhbG-jPIS_DDlhguSyVXphKlsW5gW4cMHS64qJTAisqxMJNSwe8QBpNxXxQsmY0xqeZTQLQHbNbJ4' });

    onMessage(messaging, (payload) => {
      const title = payload.notification.title ? payload.notification.title : '';
      const body = payload.notification.body ? payload.notification.body : '';

      if (title && body) {
        Dialog.create({
          title,
          message: body,
        });
      }
    });

    setTimeout(() => {
      isSupported().then((support) => {
        if (support) {
          Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
              // console.log(permission);
              try {
                getToken(messaging, {
                  vapidKey: 'BGuzP62iHHrhbG-jPIS_DDlhguSyVXphKlsW5gW4cMHS64qJTAisqxMJNSwe8QBpNxXxQsmY0xqeZTQLQHbNbJ4',
                }).then((token) => {
                  // console.log(token);
                  this.updatePushToken(token);
                  this.saveUserPushToken();
                });
              }
              catch (error) {
                this.$q.dialog({
                  title: 'error',
                  message: error.message,
                });
              }
            }
          });
        }
      });
    }, 6000);
  },

  methods: {
    ...mapActions('account', ['saveUserPushToken']),
    ...mapMutations('account', ['updatePushToken']),
    handleBackButton() {
      if (this.$route.path === '/login' || this.$route.path === '/shifts') {
        navigator.app.exitApp();
      }
    },
  },
};
</script>
